import { Metadata, resolveDateRange } from '@dx-ui/dx-common';
import useSetupUsage, {
  SetupUsage,
} from '@dx-ui/dx-common/src/utils/useSetupUsage';
import {
  createColumnsDespatchAdvice,
  createColumnsExtendedInvoiceDetails,
  createColumnsOrder,
  createColumnsProcessDetails,
  createColumnsTransportDetails,
  createCommonColumns,
  createCommonFilters,
  createDespatchAdviceFilters,
  createExtendedInvoiceDetailsFilters,
  createOrderFilters,
  createProcessDetailsFilters,
  createTransportDetailsFilters,
} from '../../aspects';
import { CommonList, DisplayContextualButtons } from '../../shared';

/**
 * Declare the additional columns to display vs commons
 */
const columns: any[] = [
  ...createCommonColumns(),
  ...createColumnsOrder(),
  ...createColumnsProcessDetails(),
  ...createColumnsDespatchAdvice(),
  ...createColumnsTransportDetails(),
  ...createColumnsExtendedInvoiceDetails(),
];

/**
 * Specific filters
 */
const additionalFilters: any[] = [
  ...createCommonFilters(),
  ...createOrderFilters(),
  ...createProcessDetailsFilters(),
  ...createDespatchAdviceFilters(),
  ...createTransportDetailsFilters(),
  ...createExtendedInvoiceDetailsFilters(),
];
/**
 * @param {*} props
 */
const WayBillList = (props) => {
  const setupUsage: SetupUsage | undefined = useSetupUsage();
  const isDemoSetup: boolean = setupUsage === SetupUsage.DEMO;
  return (
    <CommonList
      title='dxMessages.waybill.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      contextualToolbar={<DisplayContextualButtons />}
      filterDefaultValues={
        isDemoSetup
          ? {}
          : {
              [Metadata.created]: resolveDateRange({
                predefinedRange: 'last-7-days',
              }),
            }
      }
    />
  );
};

export default WayBillList;
